import { render, staticRenderFns } from "./AmenitiesList.vue?vue&type=template&id=b3f49d96&lang=pug"
import script from "./AmenitiesList.vue?vue&type=script&lang=js"
export * from "./AmenitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports